import React, { createContext, useContext } from 'react';
import { AuthClient } from '@shared-types/form';

const AuthClientContext = createContext<AuthClient | undefined>(undefined);

export const AuthClientProvider = ({ client, children }: { client: AuthClient; children: React.ReactNode }) => (
  <AuthClientContext.Provider value={client}>
    {children}
  </AuthClientContext.Provider>
);

export const useAuthClient = (): AuthClient | undefined => useContext(AuthClientContext);
